import parse from 'date-fns/parse';

import { COMMON_DATETIME_FORMATS } from 'reservations/base/helpers/datetime';

export function getDateTime(date: Date, availability: string): Date {
  return parse(
    `${COMMON_DATETIME_FORMATS.YMMdd(date)} ${availability}`,
    'y-MM-dd h:mm a',
    new Date()
  );
}
